;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "aganMobileAccordion",
        defaults = {},
        $ratingsTabHTML = "",
        ratingsTabContainer = $("#ratings-yotpo-widget");

    /**
     * Constructor
     * @param element
     * @param options
     * @constructor
     */
    function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this._$element = $(this.element);
        this.init();
    }

    $.extend(Plugin.prototype, {

        /**
         * jquery constructor
         */
        init: function () {
            var self = this;

            this._bindDesktopTabsEvent();
            this._bindMobileTabsEvents();
            this._initReviews();
        },

        /**
         * @private
         */
        calculateBrowserWidth: function () {

            return Math.max(
                document.body.scrollWidth,
                document.documentElement.scrollWidth,
                document.body.offsetWidth,
                document.documentElement.offsetWidth,
                document.documentElement.clientWidth
            );

        },

        /**
         * @private
         */
        initYotpoRatings: function (scrollToRatingTab = false) {
            if (Yotpo != undefined) {
                var api = new Yotpo.API(yotpo);
                api.refreshWidgets();
                if (scrollToRatingTab) {
                    document.querySelector("#ratings").scrollIntoView(true);
                }
            }
        },

        /**
         * @param tabId
         * @private
         */
        toggleTab: function (tabId, event, forceOpen = false) {

            if ($(".yotpo-main-widget").length > 0 && $(".yotpo-main-widget").children().length == 0) {
                this.initYotpoRatings();
            }

            const tabs = this._$element.find('.tabbed-content-tabs'),
                buttons = tabs.find('a'),
                item = tabs.parents('.tabbed-content').find('.tabbed-content-item'),
                targetTab = buttons.filter('[href="' + tabId + '"]');

            // avoid activation of invalid tabs
            if (!targetTab.length) return;

            // when link has no href, we scroll manually
            if (event && (event.target.getAttribute("href") === undefined ||
                !event.target.getAttribute("href")?.includes("#"))) {
                document.querySelector(tabId).scrollIntoView(true);
            }

            let tabIsOpen = targetTab.hasClass("active");

            buttons.removeClass('active');
            item.removeClass('active');

            const currentBrowserWidth = this.calculateBrowserWidth();
            if (!tabIsOpen || forceOpen || currentBrowserWidth >= 1024) {
                targetTab.addClass('active');
                $(tabId).addClass('active');
            } else {
                event.preventDefault();
            }
        },

        /**
         * @private
         */
        _initReviews: function () {

            const self = this;

            if ($("#ratings").length > 0) {
                $.get('/?cl=tpl&tpl=ajax_productdetails_reviews_widget.tpl&oxid=' + ratingsTabContainer.attr("data-oxid") + '&oxartnum=' + ratingsTabContainer.attr("data-oxartnum") + '&parent_oxartnum=' + ratingsTabContainer.attr("data-parent-oxartnum"),
                    function (oData, sStatus, oXhr) {
                        $ratingsTabHTML = oData;
                        ratingsTabContainer.html($ratingsTabHTML);

                        if ($("#ratings").hasClass("active")) {
                            self.initYotpoRatings(true);
                        }
                    }
                );
            }
        },

        /**
         * @private
         */
        _bindDesktopTabsEvent: function () {

            const self = this;
            this._$element.find('.tabbed-content-tabs a').on('click', function (event) {
                event.preventDefault();
                self.toggleTab($(this).attr('href'), event);
            });
        },


        /**
         * @private
         */
        _bindMobileTabsEvents: function () {

            const self = this;
            this._$element.find('.tabbed-content-accordion-tab').on('click tap', function (event) {
                const $parent = $(this).parent();
                self.toggleTab(`#${$parent.attr('id')}`, event);
            });
        },

    });

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" +
                    pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);
